export default (to, from, next) => {
  next()
  const userInfo = window.localStorage.getItem('userInfo')
  const fingerprint = window.localStorage.getItem('fingerprint')
  if (userInfo != null && userInfo.length > 0 && fingerprint != null) {
    next()
  } else {
    window.localStorage.removeItem('userInfo')
    next('/app/sessions/signIn')
  }
}
